export default __webpack_public_path__ + "static/media/13-quantize.2f082103.jpg";